import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createManifestValidationForm } from "../../utils/validationSchema";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "./Combobox";
import BranchComboboxInput from "../Reusable/Form/ComboboxInput";
import Form from "../../layouts/Form";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
import TextField from "../Reusable/Form/TextInput";
import Spinner from "../Reusable/Spinner";
import { downloadApiData } from "../../helpers/AxiosInstance";
import moment from "moment";
import { ClipboardEvent } from "react"
import { toast } from "react-toastify";


const EditManifest = (props: any) => {
  const { handleEdit, isLoading, data, handleAttachConsignment, handlePrint, isPrintLoading, handleToggleMarkAsDone, handleDeleteManifestItem } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createManifestValidationForm),
    defaultValues: async () => {
      return {
        driver: {
          name: data?.driver?.full_name,
          value: data?.driver?.id
        },
        vehicle: {
          name: data?.vehicle?.name,
          value: data?.vehicle?.id
        },
        destination_branch: {
          name: data?.destination_branch?.name,
          id: data?.destination_branch?.id
        },
        note: data?.note
      }
    }
  });

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter' && event.target.value?.length > 0) {
      handleAttachConsignment(event.target.value)
      event.target.value = ''
    }
  };

  const defaultColumns: any = [
    {
      header: "Waybill",
      accessorKey: "order.tracking_number",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "order.sender.full_name",
      cell: NACell,
    },
    {
      header: "Receiver",
      accessorKey: "order.receiver.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },
    {
      header: "Piece",
      accessorKey: "order.total_piece",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <div className="flex gap-x-4 justify-center items-center">
          <TableActionButton editPath={`/order/edit/${row?.original?.order?.id}`} />
          <button onClick={() => handleDeleteManifestItem(getValue())}>Delete</button>
        </div>
      ),
    },
  ]

  const handleDownloadExcel = async () => {
    try {
      await downloadApiData(`/manifest/${data?.id}/download-excel-manifest/`, `${moment().format('MMMM-Do-YYYY-h-mm-ss')}.xlsx`)
    } catch (e) {
      console.log(e)
    }
  };

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    toast.error("Copy and paste is not allowed here")
  }

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
        disabled={!data?.is_active}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 mx-4">
          <ComboboxInput
            url={APIS.VEHILCE}
            queryKey={"vehicle"}
            register={register("vehicle")}
            errors={errors?.vehicle}
            name={"vehicle"}
            label={"Vehicle Number"}
            setValue={setValue}
            placeholder={"Search vehicle"}
            getValues={getValues}
            clearErrors={clearErrors}
            disabled={!data?.is_active}
          />
          <ComboboxInput
            url={APIS.DRIVER}
            queryKey={"driver"}
            register={register("driver")}
            errors={errors?.driver}
            name={"driver"}
            label={"Driver"}
            setValue={setValue}
            placeholder={"Search driver"}
            getValues={getValues}
            clearErrors={clearErrors}
            disabled={!data?.is_active}
          />
          <BranchComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("destination_branch")}
            errors={errors?.destination_branch}
            name={"destination_branch"}
            label={"Branch"}
            setValue={setValue}
            placeholder={"Search branch"}
            getValues={getValues}
            clearErrors={clearErrors}
            disabled={!data?.is_active}
          />
        </div>
        <div className="mx-4">
          <TextField
            label={"Note"}
            register={register(`note`, { disabled: !data?.is_active })}
            errors={errors?.note}
          />
        </div>
      </Form>
      <Card title="Barcode Scanner">
        <div className="grid grid-cols-1">
          <div>
            <input type="text" className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1" onPaste={preventCopyPaste} disabled={!data?.is_active} onKeyDown={handleKeyDown} />
          </div>
        </div>
      </Card>
      <DataTable
        url={APIS.MANIFEST_ITEMS}
        queryKey={"manifest-items"}
        columns={defaultColumns}
        params={{ manifest: data?.id }}
        tableName={"manifest-items"}
        actionMenu={<div className="w-full text-right">
          {data?.is_active ? <button className="p-1 px-5 rounded-sm border border-primary mr-2" onClick={handleToggleMarkAsDone}>Mark As Done</button> : ""}
          <button className="p-1 px-5 rounded-sm border border-primary mr-2" onClick={handleDownloadExcel}>{"Download Excel"}</button>
          <button className="p-1 px-5 rounded-sm border border-primary" disabled={isPrintLoading} onClick={() => handlePrint()}>{isPrintLoading ? <Spinner /> : "Print"}</button>
        </div>}
      />
    </>
  );
};

export default EditManifest;